import React from 'react'
import {routes} from 'routes/routes'
import Shape1 from 'assets/img/shape/join-shape-1.png'
import Shape2 from 'assets/img/shape/join-shape-2.png'
import hometalker from 'assets/custom_images/hometalker.png'
import {LocalLink} from 'i18n/LocalLink'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'
import {withLocalePath} from 'i18n/localePaths'

export function WhyOnlineEvent() {
  const {locale, t} = useI18n()
  const orgLoginUrl = withLocalePath(locale, routes.organization.login)

  return (
    <section
      className="join__area p-relative  z-index-1 fix"
      style={{backgroundImage: `url(${hometalker})`}}
    >
      <div className="join__all-shape p-relative">
        <img
          className="join__shape-1"
          src={Shape1}
          style={{width: 'auto', height: 'auto'}}
          alt=""
        />
        <img
          className="join__shape-2"
          src={Shape2}
          style={{width: 'auto', height: 'auto'}}
          alt=""
        />
        <div className="container">
          <div className="join__main-wrapper pt-150 pb-90">
            <div className="row align-items-sm-start">
              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <div className="join__features-wrapper mb-60">
                  <div className="join__features-grid">
                    <div className="join__features-item text-center">
                      <div className="join__features-icon">
                        <span>
                          <i className="flaticon-network"></i>
                        </span>
                      </div>
                      <h3 className="join__features-title">
                        {t('whyEvent.featNetwork')}
                      </h3>
                    </div>
                    <div className="join__features-item text-center">
                      <div className="join__features-icon">
                        <span>
                          {' '}
                          <i className="flaticon-dashboard-2"></i>
                        </span>
                      </div>
                      <h3 className="join__features-title">
                        {t('whyEvent.featBuilder')}
                      </h3>
                    </div>
                    <div className="join__features-item text-center">
                      <div className="join__features-icon">
                        <span>
                          <i className="flaticon-trophy-1"></i>
                        </span>
                      </div>
                      <h3 className="join__features-title">
                        {t('whyEvent.featEasySales')}
                      </h3>
                    </div>
                    <div className="join__features-item text-center">
                      <div className="join__features-icon">
                        <span>
                          {' '}
                          <i className="flaticon-confetti"></i>
                        </span>
                      </div>
                      <h3 className="join__features-title">
                        {t('whyEvent.featFun')}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <div className="join__content-wrapper mb-60">
                  <div className="section__title-wrapper is-white mb-40">
                    <span className="section__back-title">
                      {t('whyEvent.backTitle')}
                    </span>
                    <span className="section__subtitle">
                      {t('whyEvent.subtitle')}
                    </span>
                    <h2 className="section__title">
                      {t('whyEvent.titleBefore')}{' '}
                      <span className="text__highlight">
                        {t('whyEvent.titleHighlight')}
                      </span>
                      {t('whyEvent.titleAfter')}
                    </h2>
                  </div>
                  <div className="join__content mb-70">
                    <LeadParagraph>{t('whyEvent.lead')}</LeadParagraph>
                    <StyledUL className="mt-30">
                      <li>
                        <p>
                          <span>1</span> {t('whyEvent.point1')}
                        </p>
                        <p>
                          <span>2</span> {t('whyEvent.point2')}
                        </p>
                        <p>
                          <span>3</span> {t('whyEvent.point3')}
                        </p>
                        <p>
                          <span>4</span> {t('whyEvent.point4')}
                        </p>
                        <p>
                          <span>5</span> {t('whyEvent.point5')}
                        </p>
                        <p>
                          <span>6</span> {t('whyEvent.point6')}
                        </p>
                      </li>
                    </StyledUL>
                  </div>
                  <LocalLink
                    to={orgLoginUrl}
                    className="fill__btn fill_btn_new"
                  >
                    {t('whyEvent.orgCta')}
                    <i className="fa-regular fa-angle-right"></i>
                  </LocalLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const LeadParagraph = styled.p`
  white-space: pre-line;
`

const StyledUL = styled.ul`
  & > li {
    display: flex;
    flex-flow: wrap;
    gap: 20px 0;
  }

  & > li > p {
    width: 50%;
  }
  & > li > p > span {
    background: var(--clr-theme-1);
    border-radius: 100%;
    width: 30px;
    height: 30px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    font-weight: bold;
    font-size: 1.3rem;
  }

  @media (max-width: 575px) {
    & > li > p {
      width: 100%;
    }
  }
`
